import { Dropdown, Pagination, Space, Tooltip } from "antd";
import { AiTwotoneSetting } from "react-icons/ai";
import {
  FaEdit,
  FaEllipsisV,
  FaEye,
  FaEyeSlash,
  FaInfoCircle,
  FaTrashRestoreAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Alert from "../../../../global/alert/Alert";
import { IoCloseSharp } from "react-icons/io5";
import {
  useDelete,
  useStatusChange,
} from "../../../../../utils/CustomFunctions";
import { MdDelete } from "react-icons/md";
import { useState } from "react";

export const Table3 = ({ venues }) => {
  const server = process.env.REACT_APP_SERVER;

  // this is alert maessage
  const msg = {
    icon: <FaInfoCircle className="me-3" />,
    type: "alert-info",
    text: "No venues found",
  };

  // for state change
  const { loading, handleStatusChange } = useStatusChange(
    "admin",
    "venue_change_status",
    "venues",
    "venues"
  );
  // for soft delete and parmanently delete
  const { isLoading, handleDelete } = useDelete("admin", "venues", "venues");

  // for pagination purposes
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const indexOfLastData = currentPage * itemsPerPage;
  const indexOfFirstData = indexOfLastData - itemsPerPage;
  const currentData = venues?.slice(indexOfFirstData, indexOfLastData);

  return (
    <>
      <div className="row organizer-event">
        <div className="col-12">
          {!venues || !venues.length > 0 ? (
            <Alert {...msg} />
          ) : (
            <div className="card">
              <div className="table-responsive">
                <table className="table table-hover table-vcenter">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Image</th>
                      <th>Organizer</th>
                      <th>Events count</th>
                      <th>Status</th>
                      <th className="text-center">
                        <AiTwotoneSetting />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData?.map((venue) => {
                      const items = [
                        {
                          label: (
                            <Link
                              to={`${venue.id}/edit`}
                              className="d-flex align-items-center"
                            >
                              <FaEdit className="me-1" />
                              Edit
                            </Link>
                          ),
                          key: "0",
                        },
                        {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) => handleStatusChange(e, venue.id)}
                            >
                              {venue.status === "visible" ? (
                                <>
                                  <FaEyeSlash className="me-1" />
                                  Hide
                                </>
                              ) : (
                                <>
                                  <FaEye className="me-1" /> Show
                                </>
                              )}
                            </Link>
                          ),
                          key: "1",
                        },
                        {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) =>
                                handleDelete(e, venue.id, "venue_delete", "")
                              }
                            >
                              {venue?.deleted_at !== null ? (
                                <>
                                  <FaTrashRestoreAlt className="me-1" /> Restore
                                </>
                              ) : (
                                <>
                                  <IoCloseSharp className="me-1" />
                                  Delete
                                </>
                              )}
                            </Link>
                          ),
                          key: "2",
                        },
                        venue.deleted_at && {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) =>
                                handleDelete(
                                  e,
                                  venue.id,
                                  "venue_delete_permanent",
                                  "delete_permanent"
                                )
                              }
                            >
                              <MdDelete className="me-1" />
                              Delete permanently
                            </Link>
                          ),
                          key: "3",
                        },
                      ];
                      return (
                        <tr key={venue.id}>
                          <td>
                            <Link
                              to={`/en/venue/${venue?.slug}`}
                              className="text-capitalize"
                            >
                              {venue?.name}
                            </Link>
                          </td>
                          <td>
                            <Tooltip title="Enlarge">
                              {venue?.images?.length > 0 ? (
                                <Link
                                  className="fancybox"
                                  to={`${server}/venue/image/${venue?.images?.[0].name}`}
                                  target="_blank"
                                >
                                  <img
                                    src={`${server}/venue/image/${venue?.images?.[0].name}`}
                                    className="img-thumbnail img-50-50"
                                  />
                                </Link>
                              ) : (
                                <img
                                  src="/./images/noPhoto.png"
                                  className="img-thumbnail img-50-50"
                                  alt=""
                                />
                              )}
                            </Tooltip>
                          </td>
                          <td>{venue?.user?.organize_name}</td>
                          <td>{venue?.events_count} </td>
                          <td className="">
                            <span
                              className={`badge badge-${
                                venue?.status === "visible"
                                  ? "success"
                                  : "danger"
                              } d-inline-flex align-items-center`}
                            >
                              {venue?.status === "visible" ? (
                                <>
                                  <FaEye className="me-1" /> Visible
                                </>
                              ) : (
                                <>
                                  <FaEyeSlash className="me-1" />
                                  Hidden
                                </>
                              )}
                            </span>
                            {venue?.deleted_at && (
                              <>
                                <br />
                                <br />
                                <span className="badge badge-danger d-inline-flex align-items-center">
                                  <IoCloseSharp className="me-1" />
                                  Deleted
                                </span>
                              </>
                            )}
                          </td>
                          <td className="text-center">
                            <Dropdown
                              menu={{
                                items,
                              }}
                              trigger={["click"]}
                            >
                              <a onClick={(e) => e.preventDefault()}>
                                <Space className="justify-content-center">
                                  <FaEllipsisV />
                                </Space>
                              </a>
                            </Dropdown>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>

      {venues?.length > 10 && (
        <Pagination
          current={currentPage}
          total={venues.length}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
        />
      )}
    </>
  );
};
